import { Instance, types } from 'mobx-state-tree'
import type { SelectOption } from '../../components/Select/Select'

import { IsEditingModel } from '../IsEditingModel'

const MaintenanceInstruction = IsEditingModel.named('MaintenanceInstruction')
  .props({
    id: types.integer,
    order: types.integer,
    caption: types.string,
  })


const PartNumbersBaseModel = IsEditingModel.named('PartNumbersBaseModel')
  .props({
    number: types.string,
    title: types.string,
    life_limit_flights: types.maybeNull(types.number),
    life_limit_flight_hours: types.maybeNull(types.number),
    life_limit_days: types.maybeNull(types.number),
    maintenance_flights: types.maybeNull(types.number),
    maintenance_flight_hours: types.maybeNull(types.number),
    maintenance_days: types.maybeNull(types.number),
    maintenance_instructions: types.array(MaintenanceInstruction)
  })
  .views((self) => ({
    get titleAndNumber() {
      return `${self.title} | ${self.number}`
    },
  }))
  .actions((self) => ({
    setNumber(value: typeof self.number) {
      self.number = value
    },
    setTitle(value: typeof self.title) {
      self.title = value
    },
    setLifeLimitFlights(value: typeof self.life_limit_flights) {
      self.life_limit_flights = value
    },
    setLifeLimitFlightHours(value: typeof self.life_limit_flight_hours) {
      self.life_limit_flight_hours = value
    },
    setLifeLimitDays(value: typeof self.life_limit_days) {
      self.life_limit_days = value
    },
    setMaintenanceFlights(value: typeof self.maintenance_flights) {
      self.maintenance_flights = value
    },
    setMaintenanceFlightHours(value: typeof self.maintenance_flight_hours) {
      self.maintenance_flight_hours = value
    },
    setMaintenanceDays(value: typeof self.maintenance_days) {
      self.maintenance_days = value
    },
  }
  ))
  .actions((self) => ({
    nameValidationMessages() : string {
      if (self.title.length === 0){
        return `*Required field`
      }
      return ``
    },
    numberValidationMessages() : string {
      if ( self.number.length === 0){
        return `*Required field`
      }
      return ``
    },
  }
  ))
  .views((self) => ({
    get isValid(): boolean{
      if (self.nameValidationMessages()!=''){
        console.warn('part name is not valid')
        return false
      }
      if (self.numberValidationMessages()!=''){
        console.warn('part number is not valid')
        return false
      }
      return true
    }
  })) 


export const ExistingPartNumbersModel = PartNumbersBaseModel.named('ExistingPartNumbersModel').props({
  id: types.identifierNumber,
})
.views(self => ({
  get asSelectOption(): SelectOption {
    return { value: self.id.toString(), text: self.titleAndNumber }
  }
}))

export const NewPartNumbersModel = PartNumbersBaseModel.named('NewPartNumbersModel') // No additional props, just what PartNUmbersBaseModel has

export const PartNumbersModel = types.union(ExistingPartNumbersModel, NewPartNumbersModel)

// When a part number object is edited, we edit not the instance in the part number store, but a temporary clone (in order not to change the object displayed in the table).
// However, in objects with an identifier, and are referenced by this identifier,  we can't have two instances of the same type with the same Id, so we can't create a clone.
// To circumvent this, we define a new type for editing. Now the edit clones are not of the same type, so we don't have this problem.
export const ExistingPartNumberEditCloneModel = ExistingPartNumbersModel.named('ExistingPartNumbersModelEditCloneModel')
export const NewPartNumberEditCloneModel = NewPartNumbersModel.named('NewPartNumberEditCloneModel')

export const PartNumberEditCloneModel = types.union(ExistingPartNumberEditCloneModel, NewPartNumberEditCloneModel)

export type PartNumbers = Instance<typeof PartNumbersModel>
export type ExistingPartNumbers = Instance<typeof ExistingPartNumbersModel>
export type PartNumberEditClone = Instance<typeof PartNumberEditCloneModel>
